import { motion } from 'framer-motion';

import Box from '@zenbusiness/zui/Box';
import IconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const AuthModalOverlay = superstyled({
  name: 'AuthModal',
  slot: 'Overlay',
  tag: motion.div,
  styles: ({ theme }) => ({
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  })
});

export const AuthModalContainer = superstyled({
  name: 'AuthModal',
  slot: 'Container',
  tag: motion.div,
  styles: ({ theme, $maxWidth }) => ({
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 1),
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[24],
    maxWidth: $maxWidth
      ? `min(${$maxWidth}, calc(100vw - ${theme.spacing(4)}))`
      : `min(36rem, calc(100vw - ${theme.spacing(4)}))`,
    width: '100%',
    maxHeight: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '95vh'
    }
  })
});

export const AuthModalHeader = superstyled({
  name: 'AuthModal',
  slot: 'Header',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(4, 2, 2, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  })
});

export const AuthModalContent = superstyled({
  name: 'AuthModal',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(3),
    overflowY: 'auto',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  })
});

export const AuthModalCloseButton = superstyled({
  name: 'AuthModal',
  slot: 'CloseButton',
  tag: IconButton,
  styles: () => ({
    position: 'absolute',
    right: 8,
    top: 8
  })
});

export const AuthModalLogo = superstyled({
  name: 'AuthModal',
  slot: 'Logo',
  tag: SharedAsset,
  styles: () => ({
    height: '4.7rem',
    width: 'auto'
  })
});
